import * as React from "react";
import { createRoot } from "react-dom/client";
import { TitleBadge } from "./Components/TitleBadge";

const rootEl = document.getElementById('title-badge-template');
const root = createRoot(rootEl);
const productHandle = rootEl.getAttribute('data-product-handle');
const shieldShine = rootEl.getAttribute('data-shield-shine');
const barShine = rootEl.getAttribute('data-bar-shine');
const discShine = rootEl.getAttribute('data-disc-shine');
const rEndShine = rootEl.getAttribute('data-rend-shine');

rootEl && root.render(<TitleBadge handle={productHandle} shineAssets={{
    shield: shieldShine,
    bar: barShine,
    disc: discShine,
    rEnd: rEndShine,
}} />);